import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";

import { getCurrentUserParams, loginUser } from "../../../../Backend";
import { setUserCredentials } from "../../../../Reducer";
import { Roles, WebRoutes } from "../../../../Constants";
import { hasValue, isValidEmail } from "../../../../Helpers/validations/common";
import { FormInput } from "../../../../Components";
import { loginExternalUser } from "../../../../Backend/AccountRequests";
import { objectToQueryString } from "../../../../Helpers/utils/utils";
import { EXTERNAL_AUTH_URL } from "../../../../Constants/ApiUrl";

import "./UserLoginPage.scss";
import { Authenticated, Authentication } from "../../../../Constants/TokenKeys";

export function UserLoginPage() {
  const urlParams = new URLSearchParams(window.location.search);
  const [code] = useState(urlParams.get("code"));

  const [email, setEmail] = useState();
  const [password, setPassword] = useState();
  const [errorLogin, setErrorLogin] = useState(false);
  const [externalLoginLoading, setExternalLoginLoading] = useState(false);
  const [externalLoginError, setExternalLoginError] = useState("");
  const [t] = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  //#region Effect Hooks
  useEffect(() => {
    loginWithExternal();
  }, [code]);

  //#endregion

  //#region Functions
  async function loginWithCredentials() {
    if (hasValue(email) && hasValue(password)) {
      await loginUser(email, password);
      loginSuccess();
    }
  }

  async function redirectExternal() {
    const url = EXTERNAL_AUTH_URL;
    window.location.href = url;
  }

  async function loginWithExternal() {
    if (hasValue(code)) {
      setExternalLoginLoading(true);

      const params = {
        code: code,
      };

      await loginExternalUser(objectToQueryString(params, true));
      loginSuccess();
      setExternalLoginLoading(false);
      // setExternalLoginError("");

      // if (data.success) {
      // } else {
      //   const errorMessage = data.errors[0].errorMessageKey;
      //   setExternalLoginError(errorMessage ? errorMessage : "Unknown Error");
      // }
    }
  }

  async function loginSuccess() {
    var data = await getCurrentUserParams();
    console.log(data);
    if (data.success) {
      dispatch(setUserCredentials(data.data));
      localStorage.setItem(Authentication, Authenticated);
      if (data.data.isEnabled) {
        switch (data.data.role) {
          case Roles.Admin:
            navigate(WebRoutes.UserHomePage);
            break;
          case Roles.SchoolManager:
          case Roles.IddinkSchoolManager:
            navigate(WebRoutes.SchoolHomePage);
            break;
          case Roles.IddinkEmployee:
            navigate(WebRoutes.IddinkEmployeeHome);
            break;
          case Roles.SchoolBookManager:
            navigate(WebRoutes.SchoolReturns);
            break;
          case Roles.IddinkUserManager:
            navigate(WebRoutes.UsersAdministrationPage);
            break;
          default:
            navigate(WebRoutes.NoRolePage);
            break;
        }
      } else {
        navigate(WebRoutes.UserNotEnabled);
      }
    } else {
      setErrorLogin(true);
    }
  }

  //#endregion

  return (
    <div className="user-login-page">
      <div className="user-login-page-content">
        <div className="title-wrapper">
          <span className="title">{t("Login")}</span>
          <span
            className="close"
            onClick={() => {
              navigate(WebRoutes.EntryPage);
            }}
          >
            close
          </span>
        </div>
        {externalLoginLoading ? (
          hasValue(externalLoginError) ? (
            <div className="form-wrapper">
              <span className="errors">{externalLoginError}</span>
            </div>
          ) : (
            <div className="loader-container">
              <div className="loader" />
            </div>
          )
        ) : (
          <div className="form-wrapper">
            <FormInput
              placeholder={t("Email")}
              type="text"
              value={email ? email : ""}
              errorText={t("InvalidEmailFormat")}
              error={hasValue(email) && !isValidEmail(email)}
              change={(x) => setEmail(x.trim())}
            />
            <FormInput
              placeholder={t("Password")}
              type="password"
              visibilityPassword={true}
              value={password ? password : ""}
              change={(x) => setPassword(x.trim())}
            />
            <div className="button-wrapper">
              <Button
                className="button"
                disabled={
                  !hasValue(email) ||
                  !isValidEmail(email) ||
                  !hasValue(password)
                }
                onClick={() => {
                  loginWithCredentials();
                }}
              >
                {t("Submit")}
              </Button>
              <Button
                className="button-external"
                onClick={() => {
                  redirectExternal();
                }}
              >
                {t("School account")}
              </Button>
              {errorLogin && (
                <div className="errors">{t("LoginPageError")}</div>
              )}
            </div>
          </div>
        )}
        <div className="iddink-logo">
          <img src="/InleverBlueIcon.svg" alt="image" />
          <img src="/InleverBlueLogo.svg" alt="image" />
        </div>
        <span className="sanomaCompanyText">{t("NotLoggedCompany")}</span>
      </div>
    </div>
  );
}
